export default "__VITE_ASSET__DnatSZzZ__"